import { FC } from "react";
import { Stat } from "./types";

interface MembershipHeroMobileProps {
  label: string;
  title: string;
  stats: Stat[];
  heroImage: string;
  isDark: boolean;
  bgClass: string;
  textClass: string;
}

const MembershipHeroMobile: FC<MembershipHeroMobileProps> = ({
  label,
  title,
  stats,
  heroImage,
  isDark,
  bgClass,
  textClass,
}) => {
  return (
    <div
      className={`${bgClass} rounded-0 relative flex w-full flex-col items-center gap-0 overflow-hidden pt-8 pb-10 text-center`}
    >
      <div className="relative z-0 -mb-8 flex w-full max-w-[420px] items-center justify-center">
        <img
          src={heroImage}
          alt={label}
          className="mask-fade-bottom h-auto w-full object-contain"
        />
      </div>

      <div
        className={`relative z-10 flex w-full max-w-[420px] flex-col gap-4 ${textClass}`}
      >
        <div className="flex flex-col gap-2">
          <span
            className={`text-[12px] leading-[1.4] font-light tracking-[0.22em] uppercase ${
              isDark ? "text-white/70" : "text-muted"
            }`}
          >
            {label}
          </span>
          <h2 className="text-heading-1 font-light text-balance whitespace-pre-wrap">
            {title}
          </h2>
        </div>

        {stats.length > 0 && (
          <div
            className={`mt-2 flex w-full items-stretch justify-center ${
              isDark ? "divide-x divide-white/15" : "divide-line divide-x"
            }`}
          >
            {stats.map((stat, i) => (
              <div
                key={i}
                className="flex flex-1 flex-col items-center justify-center gap-1 px-4"
              >
                <span className="text-[18px] leading-[1.2] font-medium">
                  {stat.value}
                </span>
                <span
                  className={`text-[12px] leading-[1.4] font-light ${
                    isDark ? "text-white/70" : "text-muted"
                  }`}
                >
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipHeroMobile;
